export default __webpack_public_path__ + "c584f1fc6ea0ecf47260ac6a2ef2f108.svg";